<footer>
  <div class="section bg-dark">
    <div class="container">
      <div class="row g-4 align-items-center">

        <!-- Left section -->
        <div class="col-12 col-md-6 text-center text-md-start">
          <h2 class="font-family-syne letter-spacing-1">Komo Agency</h2>

          <ul class="list-inline-dash mt-3">
            <li *ngFor="let item of footerMenu">
              <a [href]="item.link">{{ item.label }}</a>
            </li>
          </ul>

          <p class="mt-2">&copy; 2026 Komo, All Rights Reserved.</p>
        </div>

        <!-- Right section -->
        <div class="col-12 col-md-6 text-center text-md-end">

          <ul class="list-unstyled">
            <li *ngFor="let info of contactInfo">
              {{ info }}
            </li>
          </ul>

          <ul class="list-inline-sm mt-3 mt-lg-4">
            <li *ngFor="let social of socialLinks">
              <a class="button-circle button-circle-sm" [ngClass]="social.class" [href]="social.link">
                <i class="bi" [ngClass]="social.icon"></i>
              </a>
            </li>
          </ul>

        </div>

      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</footer>
